import i18n from '@/locale/i18n'

import index from '@/page/activity5G/index'
import pay from '@/page/activity5G/pay'
import question from '@/page/activity5G/question'
import result from '@/page/activity5G/result'
export default [
	{
		path: '/activity5G/index',
		component: index,
		meta: { title: i18n.t('activity5G.index.title') }
	},
    {
        path: '/activity5G/pay',
        component: pay,
        meta: { title: i18n.t('activity5G.pay.title') }
    },
    {
        path: '/activity5G/question',
        component: question,
        meta: { title: i18n.t('activity5G.question.title') }
    },
    {
        path: '/activity5G/result',
        component: result,
        meta: { title: i18n.t('activity5G.result.title') }
    },
]



// WEBPACK FOOTER //
// ./src/router/activity5G/index.js